import { useState, useEffect } from 'preact/hooks';

export function useTransition(
  isReadyToBeVisible: boolean,
  delay: number = 300
) {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(isReadyToBeVisible);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (isReadyToBeVisible) {
      setShouldRender(true);
    } else {
      setIsVisible(false);
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, delay);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isReadyToBeVisible, delay]);

  useEffect(() => {
    if (shouldRender) {
      setIsVisible(true);
    }
  }, [shouldRender]);

  return [shouldRender, isVisible] as const;
}
